import { useQuery } from "@tanstack/react-query";
import DataService from "../services/DataService";

export default function useWorkers() {
    const {
        data: workers = [],
    } = useQuery({ queryKey: ['workers'], queryFn: DataService.getWorkers, refetchOnWindowFocus: false })
    return workers
}